import * as React from "react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import env from "../../../../../env"

import {
    Action,
    ActionType,
    ActionAnchor,
} from "@tenforce/toolbox-button-push-react"
import { RowContent, Cell, CellType } from "@tenforce/toolbox-table-react"
import { ISibling } from "../index"

interface Props {
    sibling: ISibling
    dragHandler?: React.ReactNode
    isDragging?: boolean
    isDraggable?: boolean
    removeSibling: (selectionFilterId: string) => void
}

export default class SiblingRow extends React.PureComponent<Props> {
    render(): JSX.Element {
        const { sibling, dragHandler, isDragging, isDraggable } = this.props

        const icon =
            sibling.type === "smartlist"
                ? `${Symbols.SmartlistIcon} `
                : sibling.type === "list"
                ? `${Symbols.ListIcon} `
                : ""

        return (
            <RowContent
                id={`${sibling.isCurrent ? "currentSibling" : ""}`}
                extraClasses="relativeSiblingRow"
                data-ft-name={sibling.Label.toLowerCase()}
                data-ft-type={sibling.type}
            >
                <Cell type={CellType.action}>
                    <ActionAnchor
                        href={env.applicationPath + sibling.Url}
                        title={sibling.Label}
                        actionType={ActionType.block}
                        extraClasses="text-black tw-px-3"
                        data-ft-action="link"
                    >
                        <div className="no-underline tw-truncate">
                            {icon}&nbsp;
                            <span data-ft-data="name">{sibling.Label}</span>
                        </div>
                    </ActionAnchor>
                </Cell>

                {isDraggable && dragHandler}

                {sibling.Editable && (
                    <Cell
                        data-ft-action="remove"
                        type={CellType.action}
                        extraClasses={`toolbox-table__cell--0 ${
                            !!isDragging ? "" : "hiddenAction"
                        }`}
                    >
                        <Action
                            actionType={ActionType.icon}
                            onClick={this.remove}
                        >
                            {Symbols.Remove}
                        </Action>
                    </Cell>
                )}

                {sibling.isCurrent && (
                    <Cell
                        extraClasses="is-disabled toolbox-table__cell--0 "
                        type={CellType.action}
                        data-ft-current
                    >
                        <Action
                            actionType={ActionType.icon}
                            extraClasses="text-black"
                            isDisabled={true}
                        >
                            {Symbols.Confirm}
                        </Action>
                    </Cell>
                )}
            </RowContent>
        )
    }

    remove = (): void => {
        const { sibling, removeSibling } = this.props
        removeSibling(sibling.Id)
    }
}
